import { render, staticRenderFns } from "./ViewerPageDesign.vue?vue&type=template&id=adb4fdf0&scoped=true"
import script from "./ViewerPageDesign.vue?vue&type=script&lang=js"
export * from "./ViewerPageDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerPageDesign.vue?vue&type=style&index=0&id=adb4fdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb4fdf0",
  null
  
)

export default component.exports